import { convertBase64ImagesInHtml, Constants } from '@/src/utils';
import {
    type ChoiceDTO,
    type MatrixRow,
    type MatrixColumn,
    type MatrixCell,
    type DragChoice,
} from '@/src/lib';

const qtm = Constants.QUESTION_TYPE_MASTER_IDS;

async function convert(value: string | undefined | null): Promise<string> {
    if (!value) return value ?? '';
    return await convertBase64ImagesInHtml(value);
}

export async function convertBase64ImagesInQuestion(question: any): Promise<void> {
    if (!question) return;
    question.prompt = await convert(question.prompt);
    question.prompt_es = await convert(question.prompt_es);
    switch (question.meta?.questionTypeMasterId) {
        case qtm.MULTIPLE_CHOICE:
        case qtm.MULTIPLE_SELECT:
            for (const choice of question.choices ?? []) {
                (choice as ChoiceDTO).text = await convert((choice as ChoiceDTO).text);
                (choice as ChoiceDTO).text_es = await convert((choice as ChoiceDTO).text_es);
            }
            break;
        case qtm.OPEN_TEXT:
            for (const choice of question.correctAnswers ?? []) {
                (choice as ChoiceDTO).text = await convert((choice as ChoiceDTO).text);
                (choice as ChoiceDTO).text_es = await convert((choice as ChoiceDTO).text_es);
            }
            break;
        case qtm.MATRIX:
            for (const row of question.rows ?? []) {
                (row as MatrixRow).text = await convert((row as MatrixRow).text);
                (row as MatrixRow).text_es = await convert((row as MatrixRow).text_es);
            }
            for (const col of question.columns ?? []) {
                (col as MatrixColumn).text = await convert((col as MatrixColumn).text);
                (col as MatrixColumn).text_es = await convert((col as MatrixColumn).text_es);
            }
            for (const cell of question.cells ?? []) {
                (cell as MatrixCell).staticContent = await convert(
                    (cell as MatrixCell).staticContent
                );
                (cell as MatrixCell).staticContent_es = await convert(
                    (cell as MatrixCell).staticContent_es
                );
            }
            break;
        case qtm.HOTSPOT:
            question.backgroundImageUrl = await convert(question.backgroundImageUrl);
            question.backgroundImageUrl_es = await convert(question.backgroundImageUrl_es);
            break;
        case qtm.DRAG_AND_DROP:
            question.backgroundImageUrl = await convert(question.backgroundImageUrl);
            question.backgroundImageUrl_es = await convert(question.backgroundImageUrl_es);
            for (const choice of question.choices ?? []) {
                (choice as DragChoice).value = await convert((choice as DragChoice).value);
                (choice as DragChoice).value_es = await convert((choice as DragChoice).value_es);
            }
            break;
    }
}
